var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2686_6788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54667 2.61731H3.33333C2.59667 2.61731 2 3.24998 2 4.02931V11.088C2 11.868 2.59667 12.5 3.33333 12.5H10.6667C11.4033 12.5 12 11.868 12 11.088V5.92131L9.39067 8.68398C9.1628 8.92764 8.86605 9.09602 8.54 9.16664L6.75267 9.54531C5.586 9.79198 4.558 8.70331 4.79133 7.46864L5.14867 5.57598C5.21333 5.23464 5.372 4.92064 5.60467 4.67464L7.54667 2.61731Z",
    fill: "#34656D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2306 1.37864C13.1632 1.20799 13.0644 1.05151 12.9393 0.917305C12.8163 0.786058 12.668 0.681062 12.5033 0.608638C12.3411 0.537396 12.1658 0.50061 11.9886 0.50061C11.8114 0.50061 11.6362 0.537396 11.474 0.608638C11.3093 0.681062 11.161 0.786058 11.038 0.917305L10.674 1.30264L12.5753 3.31597L12.9393 2.92997C13.0657 2.79679 13.1647 2.64003 13.2306 2.46864C13.368 2.11828 13.368 1.72899 13.2306 1.37864ZM11.6333 4.31397L9.7313 2.29997L6.54663 5.67331C6.49964 5.72337 6.46795 5.78582 6.4553 5.8533L6.09796 7.74664C6.0513 7.9933 6.2573 8.21064 6.48996 8.1613L8.27796 7.78331C8.34302 7.7688 8.40224 7.73513 8.44796 7.68664L11.6333 4.31397Z",
    fill: "#34656D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2686_6788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSolid);
export default __webpack_public_path__ + "static/media/edit_solid.a438e5e2f0539dbb880614e902faf073.svg";
export { ForwardRef as ReactComponent };